<template>
    <div class="border-0">
        <div class="">
            <form ref="form" data-url="admin/app/mailbox/send" class="mb-0" :class="{ 'loading-opacity': preloader }">
                <div class="form-group form-group-mailbox align-items-center justify-content-end mt-3">
                    <div class="row">
                        <div v-if="action == 'rejection'" class="col-sm-12 col-md-6 float-right">
                            <app-input id="checkbox_talentpool" type="checkbox" :list="talentpoolSelection" v-model="inputs.talentpool" />
                        </div>
                        <div v-else-if="action == 'schedule'" class="col-sm-12 col-md-6 pl-0 float-right">
                            <label for="event_date" class="col-sm-12 mb-2">
                                {{ $t("interview_date") }}
                            </label>
                            <app-input id="event_date" class="col-sm-6" type="date" dateMode="dateTime" v-model="inputs.event_date" :placeholder="$t('select_valid_date')" :required="true" />
                        </div>
                        <div v-else class="col-sm-12 col-md-6 float-right"></div>
                        <div class="col-sm-12 col-md-6 float-right">
                            <label for="inputs_title" class="col-10 mt-0 mb-2 pl-0">
                                {{ $t("choose_from_template") }}
                            </label>
                            <a href="/mail-templates" target="_blank" class="col-2 mt-1 text-right text-muted" :title="$t('edit_templates')">
                                <app-icon :name="'edit'" width="18" height="18" />
                            </a>

                            
                            <app-input id="inputs_template" class="pr-0 w-100" type="select" v-model="template" :list="templateOptions" />
                        </div>
                    </div>
                </div>

                <div class="form-group form-group-mailbox align-items-center justify-content-end">
                    <div class="avatars-w-70 w-20 float-left">
                        <img :src="this.userPhoto" class="rounded-circle" />
                    </div>
                    <div class="form-group-row" :class="{'loading-opacity': preloader}">
                        <app-overlay-loader v-if="preloader"/>
                        <app-input v-if="preloader"
                                                id="inputs_text_blind"
                                                class="col-sm-12"
                                                :class="{'loading-opacity': preloader}"
                                                type="textarea"
                                                v-model="message_blind" />
                        <app-input v-if="finishedGetData" id="textarea_field" row="3" type="text-editor" class="mb-2" :placeholder="'Zadejte text zprávy (podpis bude přidán automaticky)...'" v-model="inputs.message" />

                        <button v-if="action == 'rejection'" type="submit" class="btn btn-secondary btn-sm  pl-3 pr-3 pb-2" @click.prevent="submit">
                            <span>Odeslat zamítnutí</span>
                        </button>
                        <button v-else-if="action == 'schedule'" type="submit" class="btn btn-primary btn-sm  pl-3 pr-3 pb-2" @click.prevent="submit">
                            <span>Odeslat pozvánku</span>
                        </button>
                        <button v-else type="submit" class="btn btn-primary btn-sm pl-3 pr-3 pb-2" @click.prevent="submit">
                            <span>Odeslat</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin.js";
import GlobalHelperMixin from "../../../../../../Mixins/global/GlobalHelperMixin";

export default {
    name: "FormMailbox",
    mixins: [FormMixin, GlobalHelperMixin],
    props: {
        candidateMail: String,
        action: String,
        candidateId: [Number, String],
        candidateName: String,
        subject: String,
        userName: String,
        userPhoto: String,
    },
    watch: {
        template: {
            sync: true,
            handler(val, oldVal) {
                if (val != 0) {
                    this.getTemplateData();
                }
            },
        },
    },
    data() {
        return {
            preloader: true,
            inputs: {
                action: null,
                event_date: "",
                talentpool: "",
                message: "",
            },
            tableCommentId: "mailbox-table",
            template: 0,
            message_blind: "",
            templateOptions: [{ id: 0, value: this.$t("select") }],
            finishedGetData: false,
            talentpoolSelection: [{ id: "1", value: this.$t("save_to_talentpool") }],
        };
    },
    created() {
        if (this.action == "schedule" || this.action == "rejection") {
            $(".modal-footer").hide();
        }
        this.inputs.action = this.action;
        this.inputs.candidate_id = this.candidateId;
        this.getTemplates();
    },
    methods: {
        beforeSubmit() {
            this.preloader = true;
        },
        submit() {
            this.scrollToTop(true);

            if (this.inputs.message) {
                this.inputs.event_date = this.inputs.event_date ? moment(this.inputs.event_date).format('YYYY-MM-DD HH:mm') : null;
                this.inputs.to = this.candidateMail;
                this.inputs.toName = this.candidateName;
                this.inputs.subject = this.subject.includes("RE:") ? this.subject : "RE: " + this.subject;
            }

            this.save(this.inputs);
        },
        afterFinalResponse() {
            this.preloader = false;
            this.$emit("changed", this.inputs.message);
            this.$hub.$emit("reload-hiring");
            $(".floating-bar-fixed-bottom")
                .addClass("animate__fadeOut")
                .delay(100)
                .fadeOut();
            
            if(this.action == 'rejection' || this.action == 'schedule'){
                setTimeout(function() {
                    $("#rejection-Modal, #schedule-Modal, .modal-backdrop").hide();
                }, 10);
            }

            // @todo: Až by reaktor chtěl i onboarding bude potřeba založit účet: this.createUserAccount();
            
            this.scrollToTop(false);
        },
        afterSuccess(res) {
            this.$toastr.s(res.data.message);
            this.inputs = {};
        },
        afterError(res) {
            this.$toastr.e(res.data.message);
        },
        clear() {
            this.inputs = {};
            this.fieldStatus = {
                isSubmit: false,
            };
        },
        /**
         * Get available templates
         */
        getTemplates() {
            let url = "admin/app/templates?filter_with_status_id=1&per_page=500";
            this.axiosGet(url)
                .then((response) => {
                    const templateOptionsArray = response.data.data.map(({ name: value, ...rest }) => ({
                        value,
                        ...rest,
                    }));

                    this.templateOptions = templateOptionsArray;
                    this.templateOptions.unshift({ id: 0, value: this.$t("select") });
                })
                .catch(({ response }) => {})
                .finally(() => {
                    this.finishedGetData = true;
                    this.preloader = false;
                });
        },
        /**
         * Fill from Template
         */
        getTemplateData() {
            let selectedTemplateId = parseInt(this.template);
            let templates = this.templateOptions;
            const selectedTemplate = templates.find((o) => o.id === selectedTemplateId);

            this.finishedGetData = false;
            this.preloader = true;
            this.inputs.message = selectedTemplate.body;

            let _this = this;
            setTimeout(function() {
                _this.finishedGetData = true;
                _this.preloader = false;
            }, 200);
        },
    },
};
</script>
